<template>
  <div class="foot-warp">
    <div class="pls-footer">
      <div class="pls-footer-website">
        <div class="pls-footer-logo">
          <img id="header-img" width="173" height="63" class="header-img" src="@/assets/logo-white.svg" />
        </div>
        <div class="pls-footer-inner">
          <ul class="pls-footer-website-columns">
            <li>
              <div class="pls-footer-website-group">
                <h3 class="pls-footer-website-title"><a>{{t('foot.coreproduct.product')}}</a></h3>
                <ul class="pls-footer-website-list">
                  <li>
                    <a href="">{{t('foot.coreproduct.product1')}}</a>
                  </li>
                  <li>
                    <a href="">{{t('foot.coreproduct.product2')}}</a>
                  </li>
                  <li>
                    <a href="">{{t('foot.coreproduct.product3')}}</a>
                  </li>
                  <li>
                    <a href="">{{t('foot.coreproduct.product4')}}</a>
                  </li>
                 
                </ul>
              </div>
            </li>
            <li>
              <div class="pls-footer-website-group">
                <h3 class="pls-footer-website-title"><a>{{t('foot.myserver.server')}}</a></h3>
                <ul class="pls-footer-website-list">
                  <li>
                    <a href="">{{t('foot.myserver.server1')}}</a>
                  </li>
                  <li>
                    <a href="">{{t('foot.myserver.server2')}}</a>
                  </li>
                  <li>
                    <a href="">{{t('foot.myserver.server3')}}</a>
                  </li>
                  <li>
                    <a href="">{{t('foot.myserver.server4')}}</a>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <div class="pls-footer-website-group">
                <h3 class="pls-footer-website-title"><a>{{t('foot.sharecenter.center')}} </a></h3>
                <ul class="pls-footer-website-list">
                  <li>
                    <a href="">{{t('foot.sharecenter.center')}} </a>
                  </li>
                 
                </ul>
              </div>
            </li>
            <li>
              <div class="pls-footer-website-group">
                <h3 class="pls-footer-website-title"><a>{{t('foot.aboutus.about')}}</a></h3>
                <ul class="pls-footer-website-list">
                  <li>
                    <a style="white-space: pre-line;" href="">{{t('foot.aboutus.about1')}} </a>
                  </li>
                  <li>
                    <a style="white-space: pre-line;" href="">{{t('foot.aboutus.about2')}}</a>
                  </li>
                  <li>
                    <a style="white-space: pre-line;" href="">{{t('foot.aboutus.about3')}}</a>
                  </li>
                  <li>
                    <a style="white-space: pre-line;" href="">{{t('foot.aboutus.about4')}}</a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
          <div class="pls-footer-website-contact">
            <h3>{{t('foot.aboutus.title')}}</h3>
            <ul>
              <li><img src="@/assets/foot-1.png" />
                <h4 class="pls-footer-website-contact-title">{{t('foot.aboutus.wx')}}</h4>
              </li>
              <li><img src="@/assets/foot-2.png" />
                <h4 class="pls-footer-website-contact-title">{{t('foot.aboutus.douyin')}}</h4>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="pls-footer-blogroll-links">
        <a href="" target="_blank" class="slide" style="margin-right: 5px"><span style="margin-right: 100px;">Copyright © 2024中联智农（北京）畜牧科技有限公司</span>
           <span class="slide-text"><img
              src="https://qcloudimg.tencent-cloud.cn/raw/eed02831a0e201b8d794c8282c40cf2e.png" /><span style="margin-right: 10px;">服务协议 </span><span style="margin-right: 10px;">隐私政策 </span> 京公网安备11010502058563号 京ICP备15061576号-1
           </span>
        </a>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>

<style lang="scss" scoped>
.consultation-form-box {
  height: auto;
  box-sizing: border-box;
  background: linear-gradient(45deg, #fff, #f5f7fa, #fcfdfe);

  .consultation-form {
    width: 1280px;
    padding: 60px 20px;
    margin: 0 auto;
    @include mix.flex-container(row);
    justify-content: space-between;

    .left {
      margin-right: 250px;

      .title {
        font-weight: 500;
        font-size: 28px;
        text-align: center;
        line-height: 36px;
      }

      .text {
        margin-top: 30px;
        font-size: 16px;
        text-align: left;
        line-height: 24px;
        color: vars.$txt-color;
      }
    }

    .login-bar {
      width: 600px;
      background: rgba($color: #fff, $alpha: 1);
      height: 300px;
      box-sizing: border-box;
      border-radius: 6px;
      padding: 20px;
      box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1), 0px 0px 0px #fff;

      h3,
      p {
        text-align: center;
        color: #000;
      }

      p {
        color: #333;
        margin-top: 10px;
        font-size: 14px;
      }

      .e-button {
        cursor: pointer;
        margin: 10px auto;
        width: 90%;
        height: 32px;
        border-radius: 20px;
        line-height: 32px;
        font-size: 1rem;
        text-align: center;
        background-color: vars.$base-color;
        color: #fff;
      }
    }

    .login-describe {
      width: 96%;
      margin: 0px auto;
      @include mix.flex-container(row);
      font-size: 14px;

      .login-txt {
        margin-top: 20px;
        color: vars.$base-decoration;
      }

      .white-button {
        margin: 15px 0px 0px 15px;
        padding: 0px 10px;
        height: 24px;
        border-radius: 4px;
        line-height: 24px;
        text-align: center;
        border: 1px solid vars.$base-decoration;
        color: vars.$base-decoration;
      }
    }
  }
}

@keyframes plsFooterEnter {
  0% {
    background-position: 0 0;
  }

  100% {
    background-position: 0 -960px;
  }
}

@-webkit-keyframes plsFooterLeave {
  0% {
    background-position: 0 -960px;
  }

  100% {
    background-position: 0 0;
  }
}

@keyframes plsFooterLeave {
  0% {
    background-position: 0 -960px;
  }

  100% {
    background-position: 0 0;
  }
}

.pls-footer {
  width: 100%;
  background: vars.$base-color;
}

.pls-footer-inner {
  box-sizing: border-box;
  margin: 0 auto;
  max-width: 1280px;
  padding: 30px 0px 25px 0px;
  border-bottom: 1px solid rgba(73, 87, 112, 0.2);
  text-align: center;
  padding: 24px 36px;
  position: relative;
  display: flex;
  justify-content: space-between;
  padding-top: 40px;
  padding-bottom: 40px;
}

.pls-footer-website .pls-footer-inner {
  position: relative;
  display: flex;
  padding-top: 40px;
  padding-bottom: 40px;
}

.pls-footer-inner {
  box-sizing: border-box;
  margin: 0 auto;
  max-width: 1280px;
  padding: 30px 0px 25px 0px;
  border-bottom: 1px solid rgba(73, 87, 112, 0.2);
  -webkit-font-smoothing: antialiased;

  .pls-footer-website-columns {
    margin-left: -10px;
    display: flex;
    align-items: flex-start;
    flex: 1;

    li {
      flex: 1;
      font-size: 14px;
      text-align: left;
    }
  }
}

.pls-footer-website-title {
  margin-bottom: 15px;
  font-size: 16px;
  line-height: 22px;
  font-weight: bold;
  color: #fff;
}

.pls-footer-website-list a {
  display: block;
  padding: 4px 0;
  font-size: 14px;
  line-height: 1.5;
  color: #fff;
}

.pls-footer-website-contact {
  margin-left:20px;
  h3 {
    font-size: 24px;
    color: #fff;
    text-align: left;
    margin-bottom: 30px;
  }

  ul {
    width: 346px;
    display: flex;
    gap: 20px;

    li {
      width: 130px;
      img {
        width: 100px;
        display: block;
        width: 100px;
      }
      .pls-footer-website-contact-title {
        width: 100px;
        text-align: center;
        margin-top: 16px;
        font-weight: normal;
        font-size: 16px;
        color: #fff;
        line-height: 22px;
      }
    }
  }

  .pls-footer-website-hotline-phone-m {
    text-align: left;
    color: #fff;

    img {
      float: left;
      margin-right: 10px;
      display: block;
      width: 20px;
    }
  }
}

.pls-footer-website-hotline {
  margin-top: 20px;
}

.pls-footer-website-hotline-title {
  font-size: 12px;
  line-height: 22px;
  font-weight: normal;
  display: inline;
  margin-right: 8px;
  color: #fff;
}

.pls-footer-website-btn {
  margin-top: 24px;
  display: block;
  width: 100%;
  max-width: 194px;
  height: 34px;
  line-height: 34px;
  background: vars.$base-color;
  color: #fff;
  text-align: center;
}

.pls-footer-blogroll-links {
  height: 60px;
  line-height: 60px;
  text-align: center;
}

.pls-footer-blogroll-links .slide {
  display: inline-block;
  vertical-align: middle;
  margin-right: 15px;
  font-size: 12px;
  line-height: 22px;
  color: #fff;
  white-space: nowrap;
}

.pls-footer-blogroll-links img {
  width: 14px;
  margin-right: 5px;
}

.pls-footer-logo {
  width: 1280px;
  margin: 0 auto;
  padding: 40px 0px 20px;
}
.whitespace-pre-line {
  white-space: pre-line;
}
</style>